import { Components, Theme } from '@mui/material/styles'

export const MuiListItemAvatar: Components<Theme>['MuiListItemAvatar'] = {
  styleOverrides: {
    root: {
      minWidth: 'initial',
    },
  },
}
